import type { Role } from '@/features/auth/types';

/** The roles that may open the Outreach area. Mirrors the backend OUTREACH_USERS set when it exists. */
export function canUseOutreach(role: Role): boolean {
  return role === 'superadmin' || role === 'admin' || role === 'manager';
}
